import script from "./SiteHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteHeader.vue?vue&type=script&setup=true&lang=js"

import "./SiteHeader.vue?vue&type=style&index=0&id=b73fb022&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b73fb022"]])

export default __exports__